/**
 * Foto con AVIF + WebP de respaldo. Siempre con width/height explícitos
 * para no regresar el CLS (0.002 medido) y lazy salvo el hero.
 * Acepta srcSet responsivo para no bajar 1200px en un hueco de 662px.
 */
export function Photo({
  avif,
  webp,
  avifSrcSet,
  webpSrcSet,
  width,
  height,
  alt,
  title,
  className,
  sizes,
  priority = false,
}: {
  avif: string;
  webp: string;
  avifSrcSet?: string;
  webpSrcSet?: string;
  width: number;
  height: number;
  alt: string;
  /** Título SEO/tooltip de la imagen. */
  title?: string | undefined;
  className?: string;
  sizes?: string;
  /** Solo para la primera foto visible de una página: es la candidata a LCP. */
  priority?: boolean;
}) {
  return (
    <picture>
      <source type="image/avif" srcSet={avifSrcSet ?? avif} sizes={sizes} />
      {webpSrcSet ? <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} /> : null}
      <img
        src={webp}
        width={width}
        height={height}
        sizes={sizes}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        decoding={priority ? "sync" : "async"}
        alt={alt}
        title={title}
        className={className}
        /* Placeholder: nunca un hueco blanco mientras carga la foto */
        style={{ backgroundColor: "var(--surface-sunken)" }}
      />
    </picture>
  );
}
